import { render, staticRenderFns } from "./MessageTimeoutPrompt.vue?vue&type=template&id=923d8a38&scoped=true&"
import script from "./MessageTimeoutPrompt.vue?vue&type=script&lang=ts&"
export * from "./MessageTimeoutPrompt.vue?vue&type=script&lang=ts&"
import style0 from "./MessageTimeoutPrompt.vue?vue&type=style&index=0&id=923d8a38&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "923d8a38",
  null
  
)

export default component.exports